import { render, staticRenderFns } from "./MatrixComposableConf.vue?vue&type=template&id=0489c8e7"
import script from "./MatrixComposableConf.vue?vue&type=script&lang=js"
export * from "./MatrixComposableConf.vue?vue&type=script&lang=js"
import style0 from "./MatrixComposableConf.vue?vue&type=style&index=0&id=0489c8e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports